document.addEventListener("DOMContentLoaded", function () {
    initProductPage();
    initShippingBox();
    initCustomGalleryScrollbar();
});

function initProductPage() {
    const addToCartButton = document.getElementById("open-easy-checkout");
    const addToCartButtonFooter = document.getElementById(
        "open-easy-checkout-footer",
    );
    const variantInput = document.getElementById("product-variant-selected");
    const productMediaGallery = document.getElementById(
        "product-media-gallery",
    );

    if (!addToCartButton && !addToCartButtonFooter) return;

    const mainButton = addToCartButton || addToCartButtonFooter;

    const productData = safeParseJSON(mainButton.dataset.product, {});
    const productVariants = Array.isArray(productData.variants)
        ? productData.variants
        : [];

    const productMedia = safeParseJSON(
        document.getElementById("product-media-json")?.textContent,
        [],
    );

    const initialVariant =
        productVariants.find(
            (variant) =>
                String(variant.id) ===
                String(getVariantIdFromUrl() || variantInput?.value || ""),
        ) ||
        productVariants.find((variant) => variant.available) ||
        productVariants[0] ||
        null;

    const radiosColor = document.querySelectorAll(
        '.swatch-input__input[type="radio"]',
    );
    const radiosTalla = document.querySelectorAll(
        '.input-button-swatch[type="radio"]',
    );

    let sliderEnabled = false;
    let currentIndex = 0;
    let dragging = false;
    let startPos = 0;
    let translate = 0;
    let prevTranslate = 0;

    const requestIdle =
        window.requestIdleCallback ||
        function (callback) {
            setTimeout(callback, 1);
        };

    const colorGroups = buildColorGroups(productVariants, productMedia);

    radiosColor.forEach((radio) => (radio.checked = false));
    radiosTalla.forEach((radio) => (radio.checked = false));

    const mobileGalleryNav = document.getElementById("mobileGalleryNav");
    const mobileGalleryPrev = document.getElementById("mobileGalleryPrev");
    const mobileGalleryNext = document.getElementById("mobileGalleryNext");
    const mobileGalleryThumb = document.getElementById("mobileGalleryThumb");
    const mobileGalleryCounter = document.getElementById(
        "mobileGalleryCounter",
    );

    enableGallerySliderOnIntent();
    bindVariantRadios();
    bindVariantInputChange();
    observeUrlChanges();

    if (mobileGalleryPrev) {
        mobileGalleryPrev.addEventListener("click", function () {
            goToGalleryIndex(currentIndex - 1);
        });
    }

    if (mobileGalleryNext) {
        mobileGalleryNext.addEventListener("click", function () {
            goToGalleryIndex(currentIndex + 1);
        });
    }

    window.addEventListener("resize", updateMobileGalleryNav);

    if (productVariants.length === 1) {
        handleSingleVariantProduct(productVariants[0]);
        return;
    }

    if (initialVariant) {
        applyVariant(initialVariant.id, {
            syncUrl: false,
            syncOptions: true,
            syncInput: true,
            updateGallery: true,
            updateButton: true,
        });
    } else {
        restoreOriginalButton();
    }

    function safeParseJSON(value, fallback) {
        try {
            return value ? JSON.parse(value) : fallback;
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return fallback;
        }
    }

    function getVariantIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("variant");
    }

    function updateUrlVariant(variantId) {
        if (!variantId) return;

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variantId);
        history.replaceState({}, "", url.toString());
    }

    function setButtonLoading(button, isLoading) {
        if (!button) return;
        button.classList.toggle("loading", isLoading);
    }

    function setButtonsState(callback) {
        [addToCartButton, addToCartButtonFooter].forEach((button) => {
            if (button) callback(button);
        });
    }

    function getDefaultButtonHTML() {
        return `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
              <g fill="none" stroke="#fff" stroke-width="4">
                  <path stroke-linejoin="round" d="M6 15h36l-2 27H8z" clip-rule="evenodd"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 19V6h16v13"/>
                  <path stroke-linecap="round" d="M16 34h16"/>
              </g>
          </svg>
          <span>Añadir a la cesta</span>
      `;
    }

    function getColorFromVariant(variant) {
        return variant?.option1 ? variant.option1.trim() : "";
    }

    function buildColorGroups(variants, media) {
        const groups = {};
        const variantsWithMedia = variants.filter(
            (variant) => variant.featured_media,
        );

        variantsWithMedia.forEach((variant, index) => {
            const start = (variant.featured_media.position || 1) - 1;
            const nextVariant = variantsWithMedia[index + 1];

            const end = nextVariant
                ? media.findIndex(
                      (item) =>
                          item.position === nextVariant.featured_media.position,
                  )
                : media.length;

            const color = getColorFromVariant(variant);

            if (color) {
                groups[color] = media.slice(
                    start,
                    end === -1 ? media.length : end,
                );
            }
        });

        return groups;
    }

    function selectOptionsForVariant(variant) {
        if (!variant) return;

        if (variant.option1) {
            radiosColor.forEach((radio) => {
                radio.checked = radio.value === variant.option1;
            });
        }

        if (variant.option2) {
            radiosTalla.forEach((radio) => {
                radio.checked = radio.value === variant.option2;
            });
        }
    }

    function findVariantBySelectedOptions() {
        const selectedColor = document.querySelector(
            '.swatch-input__input[type="radio"]:checked',
        )?.value;
        const selectedSize = document.querySelector(
            '.input-button-swatch[type="radio"]:checked',
        )?.value;

        return productVariants.find((variant) => {
            const matchesColor = selectedColor
                ? variant.option1 === selectedColor
                : true;
            const matchesSize = selectedSize
                ? variant.option2 === selectedSize
                : true;

            return matchesColor && matchesSize;
        });
    }

    function syncHiddenVariantInput(variantId) {
        if (!variantInput) return;

        const currentValue = variantInput.value;
        const nextValue = variantId ? String(variantId) : "";

        if (currentValue === nextValue) return;

        variantInput.value = nextValue;
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function restoreOriginalButton() {
        if (variantInput) variantInput.value = "";

        setButtonsState((button) => {
            button.disabled = false;
            button.innerHTML = getDefaultButtonHTML();
            button.onclick = async function () {
                setButtonLoading(button, true);
                try {
                    await handleOpenPopUpEasyCheckout(button);
                } catch (error) {
                    console.error(error);
                } finally {
                    setButtonLoading(button, false);
                }
            };
        });
    }

    function updateButtonForVariant(variant) {
        if (!variant) {
            restoreOriginalButton();
            return;
        }

        if (variant.available) {
            setButtonsState((button) => {
                button.disabled = false;
                button.innerHTML = getDefaultButtonHTML();
                button.onclick = async function () {
                    setButtonLoading(button, true);
                    try {
                        await addToCartAndOpenMinicart(variant.id, 1);
                    } catch (error) {
                        console.error(error);
                    } finally {
                        setButtonLoading(button, false);
                    }
                };
            });
        } else {
            setButtonsState((button) => {
                button.disabled = true;
                button.textContent = "Agotado";
                button.onclick = null;
            });
        }
    }

    function handleSingleVariantProduct(variant) {
        if (!variant) {
            restoreOriginalButton();
            return;
        }

        syncHiddenVariantInput(variant.id);
        renderGalleryForVariant(variant);
        updateButtonForVariant(variant);
    }

    function buildMediaItem(media, eager = false) {
        if (media.media_type === "image") {
            const src =
                media.src ||
                media.preview_image?.src ||
                media.preview_image ||
                "";

            if (!src) return "";

            return `
              <div class="image-product-gallery-container">
                  <img
                      class="image-product-gallery fade-in"
                      src="${src.startsWith("//") ? `https:${src}` : src}"
                      ${eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"'}
                      alt=""
                  >
              </div>
          `;
        }

        if (
            media.media_type === "video" &&
            Array.isArray(media.sources) &&
            media.sources[0]?.url
        ) {
            return `
              <div class="image-product-gallery-container">
                  <video
                      class="video-product-gallery fade-in"
                      loop
                      playsinline
                      autoplay
                      muted
                      preload="metadata"
                  >
                      <source src="${media.sources[0].url.startsWith("//") ? `https:${media.sources[0].url}` : media.sources[0].url}" type="video/mp4">
                  </video>
              </div>
          `;
        }

        return "";
    }

    function renderMedia(mediaArray) {
        if (!productMediaGallery) return;

        if (!mediaArray || !mediaArray.length) {
            productMediaGallery.innerHTML = "";
            return;
        }

        currentIndex = 0;
        translate = 0;
        prevTranslate = 0;

        productMediaGallery.style.transform = "translateX(0px)";
        productMediaGallery.innerHTML = mediaArray
            .map((media, index) => buildMediaItem(media, index === 0))
            .join("");

        const images = productMediaGallery.querySelectorAll("img.fade-in");
        const videos = productMediaGallery.querySelectorAll("video.fade-in");

        images.forEach((img) => {
            if (img.complete) {
                img.classList.add("loaded");
            } else {
                img.addEventListener(
                    "load",
                    function () {
                        img.classList.add("loaded");
                    },
                    { once: true },
                );
            }
        });

        videos.forEach((video) => {
            video.classList.add("loaded");
        });

        updateMobileGalleryNav();

        if (typeof window.updateCustomGalleryScrollbar === "function") {
            window.updateCustomGalleryScrollbar();
        }
    }

    function isMobileViewport() {
        return window.innerWidth <= 749;
    }

    function getGalleryItemsCount() {
        if (!productMediaGallery) return 0;
        return productMediaGallery.children.length;
    }

    function updateMobileGalleryNav() {
        if (
            !mobileGalleryNav ||
            !mobileGalleryPrev ||
            !mobileGalleryNext ||
            !mobileGalleryThumb ||
            !mobileGalleryCounter
        ) {
            return;
        }

        const total = getGalleryItemsCount();

        if (!isMobileViewport() || total <= 1) {
            mobileGalleryNav.style.display = "none";
            return;
        }

        mobileGalleryNav.style.display = "flex";

        const current = currentIndex + 1;
        mobileGalleryCounter.textContent = `${current}/${total}`;

        mobileGalleryPrev.disabled = currentIndex <= 0;
        mobileGalleryNext.disabled = currentIndex >= total - 1;

        const trackWidth = mobileGalleryThumb.parentElement.clientWidth;
        const thumbWidth = trackWidth / total;
        const maxTranslate = trackWidth - thumbWidth;
        const translateX =
            total > 1 ? (currentIndex / (total - 1)) * maxTranslate : 0;

        mobileGalleryThumb.style.width = `${thumbWidth}px`;
        mobileGalleryThumb.style.transform = `translateX(${translateX}px)`;
    }

    function goToGalleryIndex(index) {
        const total = getGalleryItemsCount();
        if (!total) return;

        currentIndex = Math.max(0, Math.min(index, total - 1));
        translate = -currentIndex * productMediaGallery.clientWidth;
        prevTranslate = translate;
        productMediaGallery.style.transform = `translateX(${translate}px)`;
        updateMobileGalleryNav();
    }

    function renderGalleryForVariant(variant) {
        if (!productMediaGallery || !variant) return;

        const color = getColorFromVariant(variant);
        const mediaGroup = colorGroups[color] || productMedia;

        requestIdle(function () {
            renderMedia(mediaGroup);
        });
    }

    function applyVariant(
        variantId,
        {
            syncUrl = true,
            syncOptions = true,
            syncInput = true,
            updateGallery = true,
            updateButton = true,
        } = {},
    ) {
        const variant = productVariants.find(
            (item) => String(item.id) === String(variantId),
        );

        if (!variant) {
            restoreOriginalButton();
            return;
        }

        if (syncOptions) {
            selectOptionsForVariant(variant);
        }

        if (syncInput) {
            syncHiddenVariantInput(variant.id);
        }

        if (updateGallery) {
            renderGalleryForVariant(variant);
        }

        if (updateButton) {
            updateButtonForVariant(variant);
        }

        if (syncUrl) {
            updateUrlVariant(variant.id);
        }
    }

    function bindVariantRadios() {
        const allRadios = [...radiosColor, ...radiosTalla];

        allRadios.forEach((radio) => {
            radio.addEventListener("change", function () {
                const variant = findVariantBySelectedOptions();

                if (!variant) {
                    restoreOriginalButton();
                    return;
                }

                applyVariant(variant.id, {
                    syncUrl: true,
                    syncOptions: false,
                    syncInput: true,
                    updateGallery: true,
                    updateButton: true,
                });
            });
        });
    }

    function bindVariantInputChange() {
        if (!variantInput) return;

        variantInput.addEventListener("change", function () {
            const variantId = this.value;

            if (!variantId) {
                restoreOriginalButton();
                return;
            }

            const variant = productVariants.find(
                (item) => String(item.id) === String(variantId),
            );

            if (!variant) {
                restoreOriginalButton();
                return;
            }

            selectOptionsForVariant(variant);
            renderGalleryForVariant(variant);
            updateButtonForVariant(variant);
        });
    }

    function observeUrlChanges() {
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        function handleUrlChange() {
            const newVariantId = getVariantIdFromUrl();

            if (!newVariantId) {
                restoreOriginalButton();
                return;
            }

            applyVariant(newVariantId, {
                syncUrl: false,
                syncOptions: true,
                syncInput: true,
                updateGallery: true,
                updateButton: true,
            });
        }

        history.pushState = function () {
            originalPushState.apply(this, arguments);
            handleUrlChange();
        };

        history.replaceState = function () {
            originalReplaceState.apply(this, arguments);
            handleUrlChange();
        };

        window.addEventListener("popstate", handleUrlChange);
    }

    function enableGallerySliderOnIntent() {
        if (!productMediaGallery) return;

        const activate = function () {
            sliderEnabled = true;
        };

        productMediaGallery.addEventListener("touchstart", activate, {
            once: true,
        });
        productMediaGallery.addEventListener("mousedown", activate, {
            once: true,
        });

        const getPointerX = (event) =>
            event.touches ? event.touches[0].clientX : event.pageX;

        productMediaGallery.addEventListener("mousedown", startDrag);
        productMediaGallery.addEventListener("touchstart", startDrag, {
            passive: true,
        });

        productMediaGallery.addEventListener("mouseup", endDrag);
        productMediaGallery.addEventListener("mouseleave", endDrag);
        productMediaGallery.addEventListener("touchend", endDrag);

        productMediaGallery.addEventListener("mousemove", drag);
        productMediaGallery.addEventListener("touchmove", drag, {
            passive: true,
        });

        function startDrag(event) {
            if (!sliderEnabled) return;
            dragging = true;
            startPos = getPointerX(event);
        }

        function drag(event) {
            if (!sliderEnabled || !dragging) return;

            translate = prevTranslate + getPointerX(event) - startPos;
            productMediaGallery.style.transform = `translateX(${translate}px)`;
        }

        function endDrag() {
            if (!sliderEnabled || !dragging) return;

            dragging = false;

            const moved = translate - prevTranslate;

            if (
                moved < -50 &&
                currentIndex < productMediaGallery.children.length - 1
            ) {
                currentIndex++;
            }

            if (moved > 50 && currentIndex > 0) {
                currentIndex--;
            }

            updatePosition();
        }

        function updatePosition() {
            translate = -currentIndex * productMediaGallery.clientWidth;
            prevTranslate = translate;
            productMediaGallery.style.transform = `translateX(${translate}px)`;
            updateMobileGalleryNav();
        }
    }
}
